import { createRouter, createWebHistory } from 'vue-router';
import Home from '../views/Home.vue';
import TestGlobePage from '../components/TestGlobePage.vue';

const router = createRouter({
    history: createWebHistory(import.meta.env.BASE_URL),
    routes: [
        {
            path: '/',
            name: 'home',
            component: Home
        },
        {
            path: '/test-globe',
            name: 'test-globe',
            component: TestGlobePage
        }
    ]
});

export default router;
